import React, { FC } from 'react';

import { Box, Typography } from '@mui/material';

import styles from './styles';

interface INoteLabelValue {
  label:string;
  value:string;
}

const NoteLabelValue:FC<INoteLabelValue> = ({ label, value }) =>
  (
    <Box sx={styles.allowanceContainer}>
      <Typography sx={styles.contractValueNote}>
        {label}
      </Typography>
      <Typography sx={styles.allowanceValue}>{value}</Typography>
    </Box>
  );

export default NoteLabelValue;
